export enum UserGroupColumns {
  NAME,
  SECTORS,
  NB_USERS,
}
